var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H17.5L17 11H13V20H11V11H7V9H11V7.128C11 5.345 11.186 4.698 11.534 4.046C11.875 3.40181 12.4018 2.87501 13.046 2.534C13.698 2.186 14.345 2 16.128 2C16.65 2 17.108 2.05 17.5 2.15V4H16.128C14.804 4 14.401 4.078 13.99 4.298C13.686 4.46 13.46 4.686 13.298 4.99C13.078 5.401 13 5.804 13 7.128V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.282a2ee4c5dad42c6a4d508ec04512c5.svg";
export { ForwardRef as ReactComponent };